/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SiloIncentivesController,
  SiloIncentivesControllerInterface,
} from "../SiloIncentivesController";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "rewardToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "emissionManager",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ClaimerUnauthorized",
    type: "error",
  },
  {
    inputs: [],
    name: "IndexOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "IndexOverflowAtEmissionsPerSecond",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidConfiguration",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidToAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUserAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyEmissionManager",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "emission",
        type: "uint256",
      },
    ],
    name: "AssetConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "AssetIndexUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "claimer",
        type: "address",
      },
    ],
    name: "ClaimerSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newDistributionEnd",
        type: "uint256",
      },
    ],
    name: "DistributionEndUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RewardsAccrued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "claimer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RewardsClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "UserIndexUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DISTRIBUTION_END",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EMISSION_MANAGER",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REVISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REWARD_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TEN_POW_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "assets",
    outputs: [
      {
        internalType: "uint104",
        name: "emissionPerSecond",
        type: "uint104",
      },
      {
        internalType: "uint104",
        name: "index",
        type: "uint104",
      },
      {
        internalType: "uint40",
        name: "lastUpdateTimestamp",
        type: "uint40",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "claimRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "claimRewardsOnBehalf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "claimRewardsToSelf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "emissionsPerSecond",
        type: "uint256[]",
      },
    ],
    name: "configureAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "getAssetData",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getClaimer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDistributionEnd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getRewardsBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "getUserAssetData",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUserUnclaimedRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "userBalance",
        type: "uint256",
      },
    ],
    name: "handleAction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "notificationReceiverPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "onAfterTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rescueRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "setClaimer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "distributionEnd",
        type: "uint256",
      },
    ],
    name: "setDistributionEnd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60c06040523480156200001157600080fd5b506040516200202838038062002028833981016040819052620000349162000065565b6001600160a01b039081166080521660a052620000a4565b6001600160a01b03811681146200006257600080fd5b50565b600080604083850312156200007957600080fd5b825162000086816200004c565b602084015190925062000099816200004c565b809150509250929050565b60805160a051611f2d620000fb6000396000818161031a01528181610646015281816106bb015261166301526000818161035b015281816105e5015281816107f70152818161094b0152610d640152611f2d6000f3fe608060405234801561001057600080fd5b506004361061014d5760003560e01c8063711ec9ac116100c3578063aaf5eb681161007c578063aaf5eb681461033c578063cbcbb50714610356578063cc69afec1461030d578063dde43cba1461037d578063f11b818814610385578063f5cf673b146103f757600080fd5b8063711ec9ac1461029b57806374d945ec146102a357806379f171b2146102e75780638b599f26146102fa578063919cd40f1461030d57806399248ea71461031557600080fd5b80633111e7b3116101155780633111e7b31461022957806331873e2e1461023c5780633373ee4c1461024f57806339ccbdd31461026257806341485304146102755780636d34b96e1461028857600080fd5b80630f1bf70d1461015257806311279b4a146101675780631652e7b714610181578063198fa81e146101ea5780632b6995dc14610221575b600080fd5b6101656101603660046119a9565b61040a565b005b604051630893cda560e11b81526020015b60405180910390f35b6101cf61018f3660046119f4565b6001600160a01b0316600090815260208190526040902054600160681b81046001600160681b039081169290821691600160d01b900464ffffffffff1690565b60408051938452602084019290925290820152606001610178565b6102136101f83660046119f4565b6001600160a01b031660009081526002602052604090205490565b604051908152602001610178565b6101656105da565b610213610237366004611a5b565b6106e4565b61016561024a366004611ab8565b610726565b61021361025d366004611aeb565b6107bd565b610165610270366004611b15565b6107ec565b610213610283366004611b2e565b610870565b610213610296366004611b7a565b61088a565b610213610931565b6102cf6102b13660046119f4565b6001600160a01b039081166000908152600360205260409020541690565b6040516001600160a01b039091168152602001610178565b6101656102f5366004611be8565b610940565b610213610308366004611c54565b610bd0565b600154610213565b6102cf7f000000000000000000000000000000000000000000000000000000000000000081565b610344601281565b60405160ff9091168152602001610178565b6102cf7f000000000000000000000000000000000000000000000000000000000000000081565b610213600181565b6103ca6103933660046119f4565b6000602081905290815260409020546001600160681b0380821691600160681b810490911690600160d01b900464ffffffffff1683565b604080516001600160681b03948516815293909216602084015264ffffffffff1690820152606001610178565b610165610405366004611aeb565b610d59565b33600090815260208190526040902054600160d01b900464ffffffffff16156105d4576000336001600160a01b03166318160ddd6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561046d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104919190611ca8565b90506001600160a01b0384166104a9578190036104ba565b6001600160a01b0383166104ba5781015b6001600160a01b03841615610546576040516370a0823160e01b81526001600160a01b0385166004820152600090839033906370a0823190602401602060405180830381865afa158015610512573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105369190611ca8565b019050610544858383610726565b505b6001600160a01b038316156105d2576040516370a0823160e01b81526001600160a01b0384166004820152600090839033906370a0823190602401602060405180830381865afa15801561059e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105c29190611ca8565b0390506105d0848383610726565b505b505b50505050565b336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161461062357604051632f1907a960e21b815260040160405180910390fd5b6040516370a0823160e01b81523060048201526106e29033906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906370a0823190602401602060405180830381865afa15801561068d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106b19190611ca8565b6001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169190610df9565b565b60006001600160a01b03821661070d57604051638aa3a72f60e01b815260040160405180910390fd5b61071b858585333387610e50565b90505b949350505050565b6000610734843384866110ec565b905080156105d4576001600160a01b038416600090815260026020526040902054610760908290611cd7565b6001600160a01b038516600081815260026020526040908190209290925590517f2468f9268c60ad90e2d49edb0032c8a001e733ae888b3ab8e982edf535be1a76906107af9084815260200190565b60405180910390a250505050565b6001600160a01b0380821660009081526020818152604080832093861683526001909301905220545b92915050565b336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161461083557604051632f1907a960e21b815260040160405180910390fd5b60018190556040518181527f1cc1849a6602c3e91f2088cadea4381cc5717f2f28584197060ed2ebb434c16f9060200160405180910390a150565b6000610880848484333333610e50565b90505b9392505050565b6001600160a01b038083166000908152600360205260408120549091339185911682146108c957604051620bb58b60e51b815260040160405180910390fd5b6001600160a01b0385166108f057604051630702b3d960e41b815260040160405180910390fd5b6001600160a01b03841661091757604051638aa3a72f60e01b815260040160405180910390fd5b610925888888338989610e50565b98975050505050505050565b61093d6012600a611dd3565b81565b336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161461098957604051632f1907a960e21b815260040160405180910390fd5b8281146109a95760405163c52a9bd360e01b815260040160405180910390fd5b60008367ffffffffffffffff8111156109c4576109c4611de2565b604051908082528060200260200182016040528015610a0f57816020015b60408051606081018252600080825260208083018290529282015282526000199092019101816109e25790505b50905060005b84811015610bc657838382818110610a2f57610a2f611df8565b90506020020135848483818110610a4857610a48611df8565b905060200201356001600160681b031614610a7657604051634266136760e11b815260040160405180910390fd5b858582818110610a8857610a88611df8565b9050602002016020810190610a9d91906119f4565b828281518110610aaf57610aaf611df8565b6020026020010151604001906001600160a01b031690816001600160a01b031681525050838382818110610ae557610ae5611df8565b90506020020135828281518110610afe57610afe611df8565b60209081029190910101516001600160681b039091169052858582818110610b2857610b28611df8565b9050602002016020810190610b3d91906119f4565b6001600160a01b03166318160ddd6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610b7a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b9e9190611ca8565b828281518110610bb057610bb0611df8565b6020908102919091018101510152600101610a15565b506105d2816111ab565b6001600160a01b038116600090815260026020526040812054818467ffffffffffffffff811115610c0357610c03611de2565b604051908082528060200260200182016040528015610c6157816020015b610c4e604051806060016040528060006001600160a01b0316815260200160008152602001600081525090565b815260200190600190039081610c215790505b50905060005b85811015610d3a57868682818110610c8157610c81611df8565b9050602002016020810190610c9691906119f4565b828281518110610ca857610ca8611df8565b60209081029190910101516001600160a01b039091169052610cf0878783818110610cd557610cd5611df8565b9050602002016020810190610cea91906119f4565b8661130f565b838381518110610d0257610d02611df8565b6020026020010151602001848481518110610d1f57610d1f611df8565b60209081029190910101516040019190915252600101610c67565b50610d4584826113eb565b610d4f9083611cd7565b9695505050505050565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610da257604051632f1907a960e21b815260040160405180910390fd5b6001600160a01b0382811660008181526003602052604080822080546001600160a01b0319169486169485179055517f4925eafc82d0c4d67889898eeed64b18488ab19811e61620f387026dec126a289190a35050565b604080516001600160a01b038416602482015260448082018490528251808303909101815260649091019091526020810180516001600160e01b031663a9059cbb60e01b179052610e4b9084906114fa565b505050565b600084600003610e6257506000610d4f565b6001600160a01b0383166000908152600260205260409020548086111561103d5760008767ffffffffffffffff811115610e9e57610e9e611de2565b604051908082528060200260200182016040528015610efc57816020015b610ee9604051806060016040528060006001600160a01b0316815260200160008152602001600081525090565b815260200190600190039081610ebc5790505b50905060005b88811015610fd557898982818110610f1c57610f1c611df8565b9050602002016020810190610f3191906119f4565b828281518110610f4357610f43611df8565b60209081029190910101516001600160a01b039091169052610f8b8a8a83818110610f7057610f70611df8565b9050602002016020810190610f8591906119f4565b8761130f565b838381518110610f9d57610f9d611df8565b6020026020010151602001848481518110610fba57610fba611df8565b60209081029190910101516040019190915252600101610f02565b506000610fe286836115d1565b9050801561103a57610ff48184611cd7565b9250856001600160a01b03167f2468f9268c60ad90e2d49edb0032c8a001e733ae888b3ab8e982edf535be1a768260405161103191815260200190565b60405180910390a25b50505b8060000361104f576000915050610d4f565b600081871161105e5786611060565b815b6001600160a01b0386166000908152600260205260409020818403905590506110898482611656565b856001600160a01b0316846001600160a01b0316866001600160a01b03167f5637d7f962248a7f05a7ab69eec6446e31f3d0a299d997f135a65c62806e7891846040516110d891815260200190565b60405180910390a498975050505050505050565b6001600160a01b03808416600090815260208181526040808320938816835260018401909152812054909190828061112588858861168a565b905080831461119f5786156111425761113f8782856117bb565b91505b6001600160a01b03808a1660008181526001870160205260409081902084905551918a16917fbb123b5c06d5408bbea3c4fef481578175cfb432e3b482c6186f02ed9086585b906111969085815260200190565b60405180910390a35b50979650505050505050565b60005b815181101561130b5760008060008484815181106111ce576111ce611df8565b6020026020010151604001516001600160a01b03166001600160a01b03168152602001908152602001600020905061124183838151811061121157611211611df8565b6020026020010151604001518285858151811061123057611230611df8565b60200260200101516020015161168a565b5082828151811061125457611254611df8565b60209081029190910101515181546cffffffffffffffffffffffffff19166001600160681b03909116178155825183908390811061129457611294611df8565b6020026020010151604001516001600160a01b03167f87fa03892a0556cb6b8f97e6d533a150d4d55fcbf275fff5fa003fa636bcc7fa8484815181106112dc576112dc611df8565b602090810291909101810151516040516001600160681b0390911681520160405180910390a2506001016111ae565b5050565b6040516370a0823160e01b81526001600160a01b03828116600483015260009182918516906370a0823190602401602060405180830381865afa15801561135a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061137e9190611ca8565b9150836001600160a01b03166318160ddd6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156113be573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113e29190611ca8565b90509250929050565b600080805b83518110156114f257600080600086848151811061141057611410611df8565b602090810291909101810151516001600160a01b0316825281019190915260400160009081208054875191935061148b91600160681b82046001600160681b039081169290811691600160d01b90910464ffffffffff16908a908890811061147a5761147a611df8565b6020026020010151604001516117e4565b90506114dc8684815181106114a2576114a2611df8565b602002602001015160200151828460010160008b6001600160a01b03166001600160a01b03168152602001908152602001600020546117bb565b6114e69085611cd7565b935050506001016113f0565b509392505050565b600061154f826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166118929092919063ffffffff16565b805190915015610e4b578080602001905181019061156d9190611e0e565b610e4b5760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b60648201526084015b60405180910390fd5b600080805b83518110156114f257611642858583815181106115f5576115f5611df8565b60200260200101516000015186848151811061161357611613611df8565b60200260200101516020015187858151811061163157611631611df8565b6020026020010151604001516110ec565b61164c9083611cd7565b91506001016115d6565b61130b6001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000168383610df9565b81546000906001600160681b03600160681b82048116919081169064ffffffffff600160d01b90910416428190036116c757829350505050610883565b60006116d5848484896117e4565b90508381146117915780816001600160681b03161461170757604051637decd25760e01b815260040160405180910390fd5b865471ffffffffffffffffffffffffffffffffffff60681b1916600160681b6001600160681b0383160264ffffffffff60d01b191617600160d01b4264ffffffffff16021787556040518181526001600160a01b038916907f5777ca300dfe5bead41006fbce4389794dbc0ed8d6cccebfaf94630aa04184bc9060200160405180910390a26117b0565b865464ffffffffff60d01b1916600160d01b4264ffffffffff16021787555b979650505050505050565b60006117c78284611e30565b6117d19085611e47565b670de0b6b3a76400009004949350505050565b6001546000908415806117f5575082155b80611808575042846001600160801b0316145b8061181c575080846001600160801b031610155b1561182a578591505061071e565b6000814211611839574261183b565b815b905060006118526001600160801b03871683611e30565b90506118606012600a611dd3565b61186a8289611e47565b6118749190611e47565b935084848161188557611885611e66565b0493506109258885611cd7565b6060610880848460008585843b6118eb5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064016115c8565b600080866001600160a01b031685876040516119079190611ea8565b60006040518083038185875af1925050503d8060008114611944576040519150601f19603f3d011682016040523d82523d6000602084013e611949565b606091505b50915091506117b082828660608315611963575081610883565b8251156119735782518084602001fd5b8160405162461bcd60e51b81526004016115c89190611ec4565b80356001600160a01b03811681146119a457600080fd5b919050565b600080600080608085870312156119bf57600080fd5b6119c88561198d565b93506119d66020860161198d565b92506119e46040860161198d565b9396929550929360600135925050565b600060208284031215611a0657600080fd5b6108838261198d565b60008083601f840112611a2157600080fd5b50813567ffffffffffffffff811115611a3957600080fd5b6020830191508360208260051b8501011115611a5457600080fd5b9250929050565b60008060008060608587031215611a7157600080fd5b843567ffffffffffffffff811115611a8857600080fd5b611a9487828801611a0f565b90955093505060208501359150611aad6040860161198d565b905092959194509250565b600080600060608486031215611acd57600080fd5b611ad68461198d565b95602085013595506040909401359392505050565b60008060408385031215611afe57600080fd5b611b078361198d565b91506113e26020840161198d565b600060208284031215611b2757600080fd5b5035919050565b600080600060408486031215611b4357600080fd5b833567ffffffffffffffff811115611b5a57600080fd5b611b6686828701611a0f565b909790965060209590950135949350505050565b600080600080600060808688031215611b9257600080fd5b853567ffffffffffffffff811115611ba957600080fd5b611bb588828901611a0f565b90965094505060208601359250611bce6040870161198d565b9150611bdc6060870161198d565b90509295509295909350565b60008060008060408587031215611bfe57600080fd5b843567ffffffffffffffff80821115611c1657600080fd5b611c2288838901611a0f565b90965094506020870135915080821115611c3b57600080fd5b50611c4887828801611a0f565b95989497509550505050565b600080600060408486031215611c6957600080fd5b833567ffffffffffffffff811115611c8057600080fd5b611c8c86828701611a0f565b9094509250611c9f90506020850161198d565b90509250925092565b600060208284031215611cba57600080fd5b5051919050565b634e487b7160e01b600052601160045260246000fd5b60008219821115611cea57611cea611cc1565b500190565b600181815b80851115611d2a578160001904821115611d1057611d10611cc1565b80851615611d1d57918102915b93841c9390800290611cf4565b509250929050565b600082611d41575060016107e6565b81611d4e575060006107e6565b8160018114611d645760028114611d6e57611d8a565b60019150506107e6565b60ff841115611d7f57611d7f611cc1565b50506001821b6107e6565b5060208310610133831016604e8410600b8410161715611dad575081810a6107e6565b611db78383611cef565b8060001904821115611dcb57611dcb611cc1565b029392505050565b600061088360ff841683611d32565b634e487b7160e01b600052604160045260246000fd5b634e487b7160e01b600052603260045260246000fd5b600060208284031215611e2057600080fd5b8151801515811461088357600080fd5b600082821015611e4257611e42611cc1565b500390565b6000816000190483118215151615611e6157611e61611cc1565b500290565b634e487b7160e01b600052601260045260246000fd5b60005b83811015611e97578181015183820152602001611e7f565b838111156105d45750506000910152565b60008251611eba818460208701611e7c565b9190910192915050565b6020815260008251806020840152611ee3816040850160208701611e7c565b601f01601f1916919091016040019291505056fea26469706673582212204b5226506ce8ed6ebe8ba106262c3693a5ce96f32fc262f8f16a68716da9fe0664736f6c634300080d0033";

type SiloIncentivesControllerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloIncentivesControllerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloIncentivesController__factory extends ContractFactory {
  constructor(...args: SiloIncentivesControllerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloIncentivesController";
  }

  deploy(
    rewardToken: string,
    emissionManager: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloIncentivesController> {
    return super.deploy(
      rewardToken,
      emissionManager,
      overrides || {}
    ) as Promise<SiloIncentivesController>;
  }
  getDeployTransaction(
    rewardToken: string,
    emissionManager: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      rewardToken,
      emissionManager,
      overrides || {}
    );
  }
  attach(address: string): SiloIncentivesController {
    return super.attach(address) as SiloIncentivesController;
  }
  connect(signer: Signer): SiloIncentivesController__factory {
    return super.connect(signer) as SiloIncentivesController__factory;
  }
  static readonly contractName: "SiloIncentivesController";
  public readonly contractName: "SiloIncentivesController";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloIncentivesControllerInterface {
    return new utils.Interface(_abi) as SiloIncentivesControllerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloIncentivesController {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as SiloIncentivesController;
  }
}
